import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Document, View, Page, Text, PDFViewer, Image, StyleSheet } from '@react-pdf/renderer';
import '../../../fontsPdf/Pdffonts';
import { format } from 'date-fns';
import imagen_la_calandria from '../../../imagenes/imagen_la_calandria.jpg';
import la_calandria from '../../../imagenes/la_calandria.jpg';

export default function DetailPDF({numDocumento, entregado, armado, cliente, articulos, totalArt, subTotal, total}){
    const date = format(new Date(), 'dd/MM/yyyy');
    
    const styles = StyleSheet.create({
        contenedorPrincipal: {
            width:"118vh",
            height:"90vh",
        },
        imagen: {
            width: "80px",
            height: "80px",
        },  
        fuente: {

        }
    })



    return(
        <div>
        {numDocumento !== undefined ?
        <PDFViewer style={styles.contenedorPrincipal}>
            <Document>
                <Page size="A4">
                    <View style={{fontFamily:"Roboto", fontWeight:"normal", fontSize:"11pt", marginTop:"40px", marginLeft:"10px", marginRight:"10px"}}>
                        <View style={{display:"flex", flexDirection:"row", justifyContent:"space-around", marginBottom:"10px", fontSize:"14pt", fontWeight:"bold"}}>
                            <Image style={styles.imagen} src={la_calandria}/>
                            <Text style={{marginTop:"50px", fontWeight: "normal"}}>La Calandria Libros</Text>
                            <Text style={{marginTop:"50px"}}>Documento N°: <Text style={{fontWeight: "bold"}}>{numDocumento}</Text></Text>                            
                        </View>
                        <View style={{display:"flex", flexDirection:"row", marginBottom:"5px"}}>
                            <Text style={{width:"300px"}}>Nombre {cliente.nombre}</Text>
                            <Text style={{width:"200px", marginLeft:"10px"}}>Cuit/Cuil/Dni: {cliente.cuitCuilDni}</Text>                            
                        </View>
                        <View style={{display:"flex", flexDirection:"row", marginBottom:"5px"}}>
                            <Text style={{width:"200px"}}>Ciudad: {cliente.ciudad}</Text>
                            <Text style={{width:"250px", paddingLeft:"2px"}}>Direccion: {cliente.direccion}</Text>
                            <Text style={{width:"60px", paddingLeft:"2px"}}>C.P: {cliente.cp}</Text>
                            <Text style={{width:"65px", paddingLeft:"2px"}}>Zona: {cliente.zona}</Text>
                        </View>
                        <View style={{display:"flex", flexDirection:"row", marginBottom:"20px"}}>
                            <Text style={{width:"150px"}}>Telefono: {cliente.telefono}</Text>
                            <Text style={{width:"420px", marginLeft:"5px"}}>Notas: {cliente.notas}</Text>
                        </View>
                        <View style={{height:"500px", marginBottom:"10px"}}>
                        <View style={{display:"flex", flexDirection:"row", marginBottom:"5px", width:"574px", height:"20px", border:"1px solid black", alignItems:"center"}}>
                           <Text style={{width:"40px", textAlign:"center"}}>Cod. Art</Text>
                           <Text style={{width:"333px", textAlign:"left", paddingLeft:"4px"}}>Articulo</Text>
                           <Text style={{width:"70px", textAlign:"center"}}>Ciclo</Text>
                           <Text style={{width:"90px", textAlign:"center"}}>ISBN</Text>
                           <Text style={{width:"40px", textAlign:"center"}}>Cant</Text>
                           {/* <Text style={{width:"50px", textAlign:"center"}}>Precio U.</Text>
                           <Text style={{width:"50px", textAlign:"center"}}>Precio T.</Text> */}
                        </View>
                        <View>
                            {articulos.map((articulo, index) => (
                                <View key={index} style={{display:"flex", flexDirection:"row", marginBottom:"5px", width:"574px", borderBottom:"1px solid black", fontSize:"9pt"}}>
                                    <Text style={{width:"40px", textAlign:"center"}}>{articulo.codArticulo}</Text>
                                    <Text style={{width:"333px", textAlign:"left", paddingLeft:"4px"}}>{articulo.nombre}</Text>
                                    <Text style={{width:"70px", fontSize:"8pt", textAlign:"center"}}>{articulo.ciclo}</Text>
                                    <Text style={{width:"90px", textAlign:"center", paddingLeft:"3px"}}>{articulo.isbn}</Text>
                                    <Text style={{width:"40px", textAlign:"right", paddingRight:"3px"}}>{articulo.cantidad}</Text>
                                    {/* <Text style={{width:"50px", textAlign:"right", paddingRight:"3px"}}>{articulo.precio}</Text>
                                    <Text style={{width:"50px", textAlign:"right", paddingRight:"3px"}}>{articulo.precioTotal}</Text> */}
                                </View>
                            ))}
                        </View>
                        </View>
                        <View>
                            <Text>Total Articulos: <Text style={{fontWeight: "bold"}}>{totalArt}</Text></Text>
                        </View>
                        <View style={{height:"100px", border:"2px"}}>
                            <Text style={{marginTop:"40px"}}>Recibido Conforme por:</Text>
                            <Text>(Firma, Aclaracion y DNI)</Text>
                        </View>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
        : "No se puede visualizar el Documento"
        }
        </div>
    )
}
